/* 4Women — Las cifras dentro de PROSA, en Lato.
 *
 * En esta marca todos los numeros de la web van en Lato. Donde el numero es un
 * dato suelto la clase `.fw-num` se pone a mano en el Liquid, y donde el texto
 * viene de un ajuste del editor lo resuelve el snippet `fw-cifras.liquid` al
 * pintar. Quedaba un tercer caso sin cubrir: los campos de TEXTO ENRIQUECIDO.
 *
 * Ahi Grace escribe parrafos completos —"Regiones: 3 dias habiles", "Los
 * Militares 6558", "Compra antes de las 11:00"— y un campo richtext no admite
 * marcar nada a mano: lo que se guarda es el HTML que produjo el editor. La
 * unica forma de alcanzarlos es envolver las cifras despues, en el navegador.
 *
 * ALCANCE: solo dentro de `rte-formatter`, que es el elemento con el que el
 * tema pinta sus campos de texto enriquecido. Deliberadamente NO se recorre la
 * pagina entera: media docena de apps meten su propio marcado en el DOM y
 * reescribirles los nodos de texto es la forma segura de romperles algo sin
 * enterarse.
 *
 * QUE SE ENVUELVE Y QUE NO
 *
 * Se envuelve la PALABRA entera, no el digito: "$79.900" y "11:00" son una sola
 * cifra aunque lleven simbolo y separadores, y partirlas dejaria el signo en una
 * tipografia y el numero en otra. Mismo criterio que fw-cifras.liquid.
 *
 * Pero a diferencia de aquel, aca se exige que la palabra NO TENGA LETRAS. En
 * los ajustes cortos del home no habia riesgo; en la prosa si: "4WOMEN" lleva un
 * digito y es el nombre de la marca, y ponerlo en Lato en mitad de un parrafo
 * canta. Con la regla "digitos y simbolos, ninguna letra" pasan $79.900, 11:00,
 * 60, 6558 y -20%, y no pasa 4WOMEN.
 *
 * IDEMPOTENTE: cada `rte-formatter` se marca al terminar, asi que un segundo
 * pase no vuelve a envolver lo ya envuelto. Hace falta porque el tema repinta
 * secciones enteras al navegar entre pestañas del acordeon.
 */
(() => {
  if (window.__fwCifras) return;
  window.__fwCifras = true;

  /* Al menos un digito y ninguna letra. \p{L} cubre acentos y ñ, que es justo
     lo que un [a-z] se comeria: "1ª" o "3°" no son cifras puras pero "año2" si
     tiene letra y debe quedar fuera. */
  const ES_CIFRA = /^[^\p{L}]*\d[^\p{L}]*$/u;

  const envolver = (raiz) => {
    if (raiz.dataset.fwCifras === '1') return;
    raiz.dataset.fwCifras = '1';

    const nodos = [];
    const w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        if (!/\d/.test(n.textContent)) return NodeFilter.FILTER_REJECT;
        const p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        /* Nada de reescribir dentro de controles, codigo o algo ya envuelto. */
        if (p.closest('.fw-num, script, style, textarea, input, select, code, pre')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    while (w.nextNode()) nodos.push(w.currentNode);

    nodos.forEach((nodo) => {
      /* Se parte conservando los separadores para poder rearmar el texto
         identico: split con grupo de captura devuelve tambien los espacios. */
      const trozos = nodo.textContent.split(/(\s+)/);
      if (!trozos.some((t) => ES_CIFRA.test(t))) return;

      const frag = document.createDocumentFragment();
      trozos.forEach((t) => {
        if (t && ES_CIFRA.test(t)) {
          const s = document.createElement('span');
          s.className = 'fw-num';
          s.textContent = t;
          frag.appendChild(s);
        } else if (t) {
          frag.appendChild(document.createTextNode(t));
        }
      });
      nodo.parentNode.replaceChild(frag, nodo);
    });
  };

  const pasarYa = () => {
    document.querySelectorAll('rte-formatter').forEach(envolver);
  };

  /* Agrupado, porque en una pagina con apps las mutaciones llegan en rafagas de
     decenas y un querySelectorAll por cada una es trabajo tirado. El
     `data-fw-cifras` ya evita reprocesar, pero no evita la busqueda.

     setTimeout y no requestAnimationFrame: rAF NO CORRE en una pestaña oculta,
     asi que en una pestaña abierta en segundo plano —o en un panel de
     previsualizacion— el primer pase se quedaba esperando indefinidamente y las
     cifras nunca se envolvian. Comprobado el 09/09: el script cargaba, habia 13
     `rte-formatter` en la pagina y ninguno quedaba marcado. */
  let pendiente = false;
  const pasar = () => {
    if (pendiente) return;
    pendiente = true;
    setTimeout(() => {
      pendiente = false;
      pasarYa();
    }, 0);
  };

  /* El primer pase va directo, sin agrupar: es uno solo y cuanto antes ocurra,
     menos posibilidad hay de que se vea el texto cambiar de tipografia. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pasarYa);
  } else {
    pasarYa();
  }

  /* El tema repinta secciones por morph —abrir una pestaña del acordeon, cambiar
     de variante, el quick-add de coleccion— y ahi llegan `rte-formatter` nuevos
     sin marcar. Un observador barato: solo mira si se agregaron nodos, y el
     `data-fw-cifras` evita el trabajo repetido. */
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes.length) {
        pasar();
        return;
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
